import React, { FC } from 'react'
import classNames from 'classnames'
import { v4 as uuid } from 'uuid'
import { HeartIcon } from '@/atoms/Icons/HeartIcon'
import { UserReaction } from '@/types/codegen-federation'
import { randomIntFromInterval } from '@/utils/numbers'

export interface Heart extends UserReaction {
  createdAt: number
  left: number
  size: number
}

function pickStartPosition() {
  return [-20, -15, -10, 0, 10, 15, 20][randomIntFromInterval(0, 6)]
}

function pickSize() {
  return [12, 15, 18, 21, 24][randomIntFromInterval(0, 5)]
}

const HEART_CENTER_OFFSET = 18

export function createHeartReaction(reactedAt: number, momentId: string) {
  const nowInMillis = new Date().getTime()
  return { left: pickStartPosition(), id: uuid(), reactedAt, createdAt: nowInMillis, size: pickSize(), momentId }
}

interface HeartProps {
  className?: string
  heart: Heart
}

export const HeartReaction: FC<HeartProps> = ({ className, heart }) => {
  return (
    <div
      style={{ left: heart.left + HEART_CENTER_OFFSET }}
      key={heart.createdAt}
      data-created={heart.createdAt}
      className={classNames('absolute animate-riseup', className)}
    >
      <HeartIcon key={heart.createdAt} size={heart.size} color1="error-500" color2="error-500" />
    </div>
  )
}
